import AttachFileIcon from '@mui/icons-material/AttachFile';
import classes from "./addCustomerElements.module.scss";
import axios from "axios";
import { useRef, useState } from 'react';

const fileApiRequestAddress = process.env.REACT_APP_FILE_ENDPOINT || window.location.origin + "/File";

const FileUploadInput = ({fieldName, onValueChange, value:initialValue}) => {
    const inputRef = useRef();
    const [value, setValue] = useState(initialValue);

    const handleFileChange = (e)=>{
        console.log(e.target.files[0]);
        if(!e?.target?.files || e.target.files.length < 1)
            return;

        const fileData = new FormData();
        fileData.append("file", e.target.files[0]);
        axios.post(fileApiRequestAddress, fileData, {
            headers: {
            "Content-Type": "multipart/form-data",
            },
            withCredentials: true,
        }).then((res) => {
        if (res?.data?.Result && res.data.Status.toUpperCase() === "OK") {
                let filePath = `File/${res.data.Result.Id}`;
                setValue(filePath);
                if(onValueChange)onValueChange(fieldName,filePath);
            }
        });
    }

    const handleFieldChange = (val) => {
        setValue(val);
        if(onValueChange)onValueChange(fieldName,val);
    }

    const onAttackFileClick = () => {
        if(inputRef)
            inputRef.current.click();
    }

    return(
        <div className="input-group" style={{width:"60%"}}>
            <input 
                type="text" 
                className="form-control shadow-none" 
                aria-label="Fileupload" 
                aria-describedby="basic-addon2"
                value={value}
                onChange={(e) => handleFieldChange(e.target.value.length > 0 ? e.target.value : null)}
                />
            <div className={`input-group-append ${classes["upload-btn"]}`}>
            <span className="input-group-text" id="basic-addon2" onClick={onAttackFileClick}><AttachFileIcon/></span>
                <input
                type="file"
                defaultValue=""
                style={{display:"none"}}
                onChange={handleFileChange}
                ref={inputRef}
                />
            </div>
        </div>

    )
}

export default FileUploadInput;